import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClosed = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M28.25,36a15.69,15.69,0,0,0-13.64,8,8.65,8.65,0,0,0-3.86-.92A8.82,8.82,0,0,0,2,52H44A15.87,15.87,0,0,0,28.25,36Z",
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36,52c4.5,4.33,11.26,8,18,8A25,25,0,0,0,75.92,47,25,25,0,0,1,47.08,11,25,25,0,0,0,29,35",
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("polygon", {
			points: "22.23 69.07 24 65.83 25.77 69.07 29 70.83 25.77 72.6 24 75.83 22.23 72.6 19 70.83 22.23 69.07",
			fill: "currentcolor",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("polygon", {
			points: "69.05 17.23 70.81 13.99 72.58 17.23 75.81 19 72.58 20.76 70.81 24 69.05 20.76 65.81 19 69.05 17.23",
			fill: "currentcolor",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("polygon", {
			points: "10.63 10.66 14.16 4.19 17.7 10.66 24.16 14.19 17.7 17.73 14.16 24.19 10.63 17.73 4.16 14.19 10.63 10.66",
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		})
	]
});
export default SvgClosed;
